import TableControls from "./TableControls";

export default TableControls;
